import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import BenefitsExplorer from "../components/BenefitsExplorer";
import { PRODUCT_BADGES } from "../data/content";
import { TOTAL_ACTIVES, TOTAL_SYSTEMS } from "../data/ingredients";

const Benefits = () => {
  const navigate = useNavigate();
  return (
    <div>
      <PageHero
        overline="Premium Daily Wellness"
        title="One sachet. Multiple systems supported."
        subtitle="Advanced daily nutrition that works in harmony with your body — supporting what matters, every single day."
      >
        <button
          onClick={() => navigate("/product")}
          data-testid="benefits-shop-now"
          className="mt-9 inline-flex items-center gap-2 bg-navy-900 text-white rounded-full px-8 py-4 font-medium hover:bg-navy-800 transition-all hover:-translate-y-0.5"
        >
          Shop Now <ArrowRight className="w-4 h-4" />
        </button>
      </PageHero>

      <section className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24 grid lg:grid-cols-12 gap-12">
        {/* floating cut-out sachet */}
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <div className="relative flex items-center justify-center py-8">
              <div className="absolute inset-0 soft-orb" />
              <img
                src="/images/brand/sachet_cut.png"
                alt="NARA sachet"
                className="relative w-auto max-h-[440px] object-contain drop-shadow-2xl animate-float"
              />
            </div>
            <div className="grid grid-cols-2 gap-3 mt-4">
              <div className="rounded-2xl bg-white border border-slate-100 p-4 text-center">
                <p className="font-heading text-2xl font-bold text-navy-900">{TOTAL_ACTIVES}+</p>
                <p className="text-[11px] text-slate-400 mt-1">Active Ingredients</p>
              </div>
              <div className="rounded-2xl bg-white border border-slate-100 p-4 text-center">
                <p className="font-heading text-2xl font-bold text-navy-900">{TOTAL_SYSTEMS}</p>
                <p className="text-[11px] text-slate-400 mt-1">Systems Supported</p>
              </div>
            </div>
          </div>
        </div>

        {/* expandable explorer */}
        <div className="lg:col-span-8">
          <Reveal className="mb-8">
            <span className="text-xs font-bold tracking-[0.22em] uppercase text-royal mb-3 block">Explore The Formula</span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-navy-900">Tap to go deeper on each system.</h2>
            <p className="mt-4 text-slate-500 leading-relaxed">Every system is powered by clinically-dosed actives. Expand a category to see how it works and the key ingredients behind it.</p>
          </Reveal>
          <BenefitsExplorer />
        </div>
      </section>

      <section className="bg-navy-900 text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
          {PRODUCT_BADGES.map((b) => (
            <span key={b} className="text-sm font-medium tracking-wide text-slate-200 flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-sky-300" /> {b}
            </span>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Benefits;
